module.exports = __webpack_public_path__ + "static/media/angle-double-prev.83a21a84.svg";